import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import RequestAppliedOffersSkeleton from '../skeleton/request-applied-offers-skeleton';
import { renderAttachment } from '../../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    wideTd: {
        minWidth: `125px`,
        maxWidth: `300px`
    }
});

const RegistrationAppliedOffers = ({ reloadOffers, reservationReqId }) => {
    const [registrationOffers, setRegistrationOffers] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState(true);
    const [, setError] = useState(null);

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        setLoading(true);
        axios.get(`/api/registrationoffer?reservationReqId=${reservationReqId}`, { headers: headers })
            .then(res => {
                setRegistrationOffers(res.data);
                setTimeout(() => setLoading(false), 750);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [reloadOffers]);

    return (
        loading ?
            <RequestAppliedOffersSkeleton />
            :
            registrationOffers.length > 0 ?
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Offer Headline</TableCell>
                                <TableCell>More Details</TableCell>
                                <TableCell>Destination</TableCell>
                                <TableCell>Create Date</TableCell>
                                <TableCell>Registration Type</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Registration Due Date</TableCell>
                                <TableCell>Requirements</TableCell>
                                <TableCell>Attachment</TableCell>
                                <TableCell>Notes</TableCell>
                                <TableCell>Created By</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                registrationOffers ?
                                    registrationOffers.map((registrationOffer, index) => (
                                        <Row key={index} row={registrationOffer} />
                                    )) :
                                    null
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <>
                    You haven't applied any offers for this request.
                </>
    );
}

const Row = ({ row }) => {
    const classes = useRowStyles();
    return (
        <React.Fragment>
            <TableRow className={classes.root}>
                <TableCell component="th" scope="row" className={classes.wideTd}>
                    {row.offerHeadline}
                </TableCell>
                <TableCell><Link to={`/offer/registration/${row.id}`}><OpenInNewOutlinedIcon /></Link></TableCell>
                <TableCell>
                    {row.destinationName}
                </TableCell>
                <TableCell className={classes.wideTd}>{row.createDate.replace('T', ' ').substring(0, 16)}</TableCell>
                <TableCell>{row.registrationType}</TableCell>
                <TableCell>{row.registrationPrice}</TableCell>
                <TableCell className={classes.wideTd}>{row.registrationDueDate.substring(0, 10)}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.registrationRequirements}</TableCell>
                <TableCell className={classes.wideTd}>{renderAttachment(row.attachment)}</TableCell>
                <TableCell className={`${classes.wideTd} no-wrap`}>{row.notes}</TableCell>
                <TableCell className={classes.wideTd}>{row.createdBy}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}


export default RegistrationAppliedOffers;